/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
export const BCActionsColumnFormatter = (
  cellContent,
  row,
  rowIndex,
  {
    openEditMerchantPage,
    openViewMerchantDialog,
    tabValues
  }
) => (
  <>
    <>
      <a
        title="Edit Merchant"
        className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3"
        onClick={() => openEditMerchantPage(row.id,'bc',tabValues)}
      >
        <span className="svg-icon svg-icon-md svg-icon-primary">
          <SVG
            src={toAbsoluteUrl("/media/svg/icons/Communication/Write.svg")}
            title="Edit Merchant"
          />
        </span>
      </a>

      <a
        title="View Merchant"
        className="btn btn-icon btn-light btn-hover-primary btn-sm mr-3"
        onClick={() => openViewMerchantDialog(row.id,'bc',tabValues)}
      >
        <span className="svg-icon svg-icon-md svg-icon-primary">
          
        <i className='fas fa-eye'></i>
        </span>
      </a>
    </>
  </>
);
